export const INFOTYPE = Object.freeze({
  WARN: 'warn',
  FAIL: 'fail',
});

export const STATUS = Object.freeze({
  COMPLETED: {
    text: 'COMPLETED',
    color: 'green',
  },
  FAILED: {
    text: 'FAILED',
    color: 'orange',
  },
  UPLOADING: {
    text: 'UPLOADING',
    color: 'grey',
  },
  IMPORTING: {
    text: 'IMPORTING',
    color: 'blue',
  },
  ANALYZING: {
    text: 'ANALYZING',
    color: 'purple',
  },
  DELETED: {
    text: 'DELETED',
    color: 'grey',
  },
});
